import { IIncomeCategoryFormValues } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider/types';
import { INCOME_SUBGROUP_CATEGORY } from 'src/Enum/IncomeStructure';

export const createNewExtendedOtherIncome = (
  formValues: IIncomeCategoryFormValues,
  subgroup: INCOME_SUBGROUP_CATEGORY,
  sequence: number
) => {
  return {
    incomeCategory: {
      nameTh: formValues.nameTh,
      nameEn: formValues.nameEn,
      subGroup: subgroup,
      sequence: sequence,
    },
  };
};
